import { render, staticRenderFns } from "./SmartSetting.vue?vue&type=template&id=8a7cd672&scoped=true"
import script from "./SmartSetting.vue?vue&type=script&lang=js"
export * from "./SmartSetting.vue?vue&type=script&lang=js"
import style0 from "./SmartSetting.vue?vue&type=style&index=0&id=8a7cd672&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7cd672",
  null
  
)

export default component.exports